import { MainContentArea, ContentHeader } from "melco-ui";
import { useTranslation } from "react-i18next";
import { LicensesList } from "../../components/licenses/LicensesList";
import { useState } from "react";
import { GenrateLicenseButton } from "../../components/licenses/GenerateLicenseButton";
import { useRolesContext } from "../../hooks/roles/useRolesContext";

// To Do: Add BreadCrum
// Add Translation
export const Licenses: React.FC = () => {
  const { t } = useTranslation();
  //const breadcrumb = useBreadcrumb("orders");
  const [openGenerateLicenseDrawer, setOpenGenerateLicenseDrawer] = useState<boolean>(false);

  const setOpenGenrateLicenseDrawerFunction = (v: boolean) => {
    setOpenGenerateLicenseDrawer(v);
  }


  const { roles } = useRolesContext();

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("main_menu.licenses")}
          extra={roles.VIRTUAL_SECURITY_GENERATE && <GenrateLicenseButton setOpenGenrateLicenseDrawerFunction={setOpenGenrateLicenseDrawerFunction} />}
        />

      }
    >

      <LicensesList openGenerateLicenseDrawer={openGenerateLicenseDrawer} setOpenGenrateLicenseDrawerFunction={setOpenGenrateLicenseDrawerFunction} />
    </MainContentArea>
  );
};
